import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from '../_shared/guards/authentication-guard';
import {NgModule} from '@angular/core';
import {SteelProfileListComponent} from './steel-profile-list/steel-profile-list.component';
import {SteelProfileDetailsComponent} from './steel-profile-details/steel-profile-details.component';
import {SteelProfileCreateComponent} from './steel-profile-create/steel-profile-create.component';
/**
 * Created by cate on 07-09-17.
 */

const steelProfileRoutes: Routes = [
    // {path: 'perfiles', component: SteelProfileListComponent, canActivate: [AuthGuard]},
    {path: 'perfil/:id', component: SteelProfileDetailsComponent, canActivate: [AuthGuard]},
    {path: 'perfiles', component: SteelProfileDetailsComponent, canActivate: [AuthGuard]},
    {path: 'crear-perfil', component: SteelProfileCreateComponent, canActivate: [AuthGuard]},
];

@NgModule({
    imports: [
        RouterModule.forChild(steelProfileRoutes)
    ],
    exports: [
        RouterModule
    ]
})

export class SteelProfileRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/steel-profile/steel-profile-routing.module.ts